export const quizTopics = [
    {
        id: "tauheed",
        title: "Tauheed",
        description: "Belief in the Oneness of Allah.",
        totalQuestions: 5,
        questions: [
            {
                id: 1,
                question: "What is the meaning of Tauheed?",
                options: ["Prophethood", "Oneness of God", "Justice", "Leadership"],
                correctAnswer: "Oneness of God"
            },
            {
                id: 2,
                question: "Does Allah have any partners?",
                options: ["Yes", "No", "Maybe", "Only in creation"],
                correctAnswer: "No"
            },
            {
                id: 3,
                question: "Which Surah purely describes Tauheed?",
                options: ["Surah Fatiha", "Surah Ikhlas", "Surah Yasin", "Surah Rahman"],
                correctAnswer: "Surah Ikhlas"
            },
            {
                id: 4,
                question: "Allah is...",
                options: ["Born", "Not born", "Created", "Dependent"],
                correctAnswer: "Not born"
            },
            {
                id: 5,
                question: "Can we see Allah with our eyes?",
                options: ["Yes", "No", "In the hereafter", "Only Prophets"],
                correctAnswer: "No"
            }
        ]
    },
    {
        id: "adl",
        title: "Adl",
        description: "Belief in the Justice of Allah.",
        totalQuestions: 5,
        questions: [
            {
                id: 1,
                question: "What does Adl mean?",
                options: ["Justice", "Mercy", "Power", "Knowledge"],
                correctAnswer: "Justice"
            },
            {
                id: 2,
                question: "Does Allah ever do injustice?",
                options: ["Yes", "No", "Sometimes", "Only to sinners"],
                correctAnswer: "No"
            },
            {
                id: 3,
                question: "Why does Allah test us?",
                options: ["For fun", "To judge our deeds", "Because He is angry", "No reason"],
                correctAnswer: "To judge our deeds"
            },
            {
                id: 4,
                question: "Is oppression compatible with Allah's nature?",
                options: ["Yes", "No", "Depends", "Unknown"],
                correctAnswer: "No"
            },
            {
                id: 5,
                question: "Every action has a...",
                options: ["Reaction", "End", "Consequence", "Meaning"],
                correctAnswer: "Consequence"
            }
        ]
    },
    {
        id: "nabuwat",
        title: "Nabuwat",
        description: "Belief in the Prophets sent by Allah.",
        totalQuestions: 5,
        questions: [
            {
                id: 1,
                question: "Who was the first Prophet?",
                options: ["Prophet Nuh (a.s)", "Prophet Adam (a.s)", "Prophet Musa (a.s)", "Prophet Ibrahim (a.s)"],
                correctAnswer: "Prophet Adam (a.s)"
            },
            {
                id: 2,
                question: "Who is the last Prophet?",
                options: ["Prophet Isa (a.s)", "Prophet Musa (a.s)", "Prophet Muhammad (PBUH)", "Prophet Dawood (a.s)"],
                correctAnswer: "Prophet Muhammad (PBUH)"
            },
            {
                id: 3,
                question: "How many Prophets (approx) were sent?",
                options: ["124,000", "12,000", "313", "1,000"],
                correctAnswer: "124,000"
            },
            {
                id: 4,
                question: "Which Prophet received the Taurat?",
                options: ["Prophet Isa (a.s)", "Prophet Musa (a.s)", "Prophet Dawood (a.s)", "Prophet Ibrahim (a.s)"],
                correctAnswer: "Prophet Musa (a.s)"
            },
            {
                id: 5,
                question: "Are Prophets infallible (Masoom)?",
                options: ["Yes", "No", "Only some", "Most of them"],
                correctAnswer: "Yes"
            }
        ]
    },
    {
        id: "imamat",
        title: "Imamat",
        description: "Belief in the 12 Successors of the Prophet.",
        totalQuestions: 5,
        questions: [
            {
                id: 1,
                question: "How many Imams are there?",
                options: ["5", "12", "14", "7"],
                correctAnswer: "12"
            },
            {
                id: 2,
                question: "Who is the first Imam?",
                options: ["Imam Ali (a.s)", "Imam Hasan (a.s)", "Imam Hussain (a.s)", "Imam Mahdi (a.s)"],
                correctAnswer: "Imam Ali (a.s)"
            },
            {
                id: 3,
                question: "Who is the 12th Imam?",
                options: ["Imam Reza (a.s)", "Imam Mahdi (a.j.t.f)", "Imam Hadi (a.s)", "Imam Askari (a.s)"],
                correctAnswer: "Imam Mahdi (a.j.t.f)"
            },
            {
                id: 4,
                question: "Is the Imam chosen by people or Allah?",
                options: ["People", "Allah", "Prophet", "Council"],
                correctAnswer: "Allah"
            },
            {
                id: 5,
                question: "Which Imam is known as Syed-ush-Shuhada?",
                options: ["Imam Ali (a.s)", "Imam Hasan (a.s)", "Imam Hussain (a.s)", "Imam Sajjad (a.s)"],
                correctAnswer: "Imam Hussain (a.s)"
            }
        ]
    },
    {
        id: "qayamat",
        title: "Qayamat",
        description: "Belief in the Day of Judgement.",
        totalQuestions: 5,
        questions: [
            {
                id: 1,
                question: "What is Qayamat?",
                options: ["Day of Festival", "Day of Judgement", "Day of Birth", "Day of Mourning"],
                correctAnswer: "Day of Judgement"
            },
            {
                id: 2,
                question: "Will everyone be resurrected?",
                options: ["Yes", "No", "Only Muslims", "Only Good people"],
                correctAnswer: "Yes"
            },
            {
                id: 3,
                question: "What will follow Qayamat?",
                options: ["Another life", "Nothing", "Heaven or Hell", "Sleep"],
                correctAnswer: "Heaven or Hell"
            },
            {
                id: 4,
                question: "Who knows the exact time of Qayamat?",
                options: ["Prophets", "Imams", "Only Allah", "Angels"],
                correctAnswer: "Only Allah"
            },
            {
                id: 5,
                question: "What is Sirat?",
                options: ["A bridge", "A mountain", "A river", "A gate"],
                correctAnswer: "A bridge"
            }
        ]
    }
];
